import {
  warningColor,
  grayColor,
  lightBlueColor
} from "assets/jss/material-dashboard-pro-react.js";

const rootDiv = document.getElementById("root");
const customStyle = rootDiv.getAttribute("customStyle");
const logo = rootDiv.getAttribute("logo");

export const initialState = {
  categories: [],
  articles: [],
  alert: null,
  cart: [],
  cartUnique: [], // CART WITH INFORMATION VISITOR
  language: "it",
  museum: {},
  reservations: [],
  events: [],
  eventSelected: {},
  shippingInfo: {
    // CONTACT
    date: "",
    firstName: "",
    lastName: "",
    email: "",
    prefix: "+39",
    telephone: ""
  },
  currency: {
    name: "EUR",
    rate: 1,
    symbol: "€"
  },
  customStyle: Object.assign(
    {},
    customStyle
      ? JSON.parse(customStyle)
      : {
          buttonBackToMenu: grayColor[1],
          buttonAction: lightBlueColor,
          buttonContinue: warningColor[0],
          buttonCart: warningColor[0],
          museoColor: "#f0f0f0"
        },
    {
      logo: logo || require("assets/img/logo.png")
    }
  ),
  // {
  //   // THE COLORS MUST BE HEX
  //   buttonBackToMenu: grayColor[1],
  //   buttonAction: lightBlueColor,
  //   buttonContinue: warningColor[0],
  //   buttonCart: warningColor[0],
  //   logo: `${config.cdn}by-foodiestrip-rosso.png`
  //
  //   // buttonBackToMenu: "#f0dddd",
  //   // buttonAction: "#0f0",
  //   // buttonContinue: "#000",
  //   // buttonCart: "#00f",
  //   // logo: `${config.cdn}sites/lib/mcdonald/mc_donalds_150.png`
  // },
  cartParams: {
    totalPrice: 0,
    deliveryCost: 0,
    servicesFees: 0,
    total: 0,
    cartCounter: 0,
    totToShow: 0,
    discount: 0,
    // EURO FOR PAYMENT
    totalPriceEuro: 0,
    servicesFeesEuro: 0,
    deliveryCostEuro: 0,
    // totalEuro,
    totToShowEuro: 0,
    vatEuro: 0
  },
  promotionalCode: {
    codice: "",
    created_at: "",
    created_by: null,
    flag_abilitato: false,
    id: null,
    organisation: null,
    sconto: 0,
    updated_at: null,
    updated_by: null,
    nome_categoria: null,
    id_categoria: null //
  }
};

export const reducer = (action, state) => {
  switch (action.type) {
    case "UPDATE_ARTICLES":
      return { ...state, articles: action.payload };
    case "UPDATE_CATEGORIES":
      return { ...state, categories: action.payload };
    case "UPDATE_ALERT":
      return { ...state, alert: action.payload };
    case "UPDATE_CART":
      return { ...state, cart: action.payload };
    case "UPDATE_LANGUAGE":
      return { ...state, language: action.payload };
    case "UPDATE_MUSEUM":
      return { ...state, museum: action.payload };
    case "UPDATE_EVENTS":
      return { ...state, events: action.payload };
    case "UPDATE_RESERVATIONS":
      return { ...state, reservations: action.payload };
    case "UPDATE_EVENT_SELECTED":
      return { ...state, eventSelected: action.payload };
    case "UPDATE_SHIPPING_INFO":
      return { ...state, shippingInfo: action.payload };
    case "UPDATE_CURRENCY":
      return { ...state, currency: action.payload };
    case "UPDATE_CUSTOM_STYLE":
      return { ...state, customStyle: action.payload };
    case "UPDATE_CART_PARAMS":
      return { ...state, cartParams: action.payload };
    case "UPDATE_PROMOTIONAL_CODE":
      return { ...state, promotionalCode: action.payload };
    case "UPDATE_CART_UNIQUE":
      return { ...state, cartUnique: action.payload };
    default:
      return state;
  }
};

export default function mapDispatchToProps(dispatch) {
  return {
    updateArticles: payload => dispatch({ type: "UPDATE_ARTICLES", payload }),
    updateCategories: payload =>
      dispatch({ type: "UPDATE_CATEGORIES", payload }),
    updateAlert: payload => dispatch({ type: "UPDATE_ALERT", payload }),
    updateCart: payload => dispatch({ type: "UPDATE_CART", payload }),
    updateLanguage: payload => dispatch({ type: "UPDATE_LANGUAGE", payload }),
    updateMuseum: payload => dispatch({ type: "UPDATE_MUSEUM", payload }),
    updateEventSelected: payload =>
      dispatch({ type: "UPDATE_EVENT_SELECTED", payload }),
    updateEvents: payload => dispatch({ type: "UPDATE_EVENTS", payload }),
    updateReservations: payload =>
      dispatch({ type: "UPDATE_RESERVATIONS", payload }),
    updateShippingInfo: payload =>
      dispatch({ type: "UPDATE_SHIPPING_INFO", payload }),
    updateCurrency: payload => dispatch({ type: "UPDATE_CURRENCY", payload }),
    updateCustomStyle: payload =>
      dispatch({ type: "UPDATE_CUSTOM_STYLE", payload }),
    updateCartParams: payload =>
      dispatch({ type: "UPDATE_CART_PARAMS", payload }),
    updatePromotionalCode: payload =>
      dispatch({ type: "UPDATE_PROMOTIONAL_CODE", payload }),
    updateCartUnique: payload =>
      dispatch({ type: "UPDATE_CART_UNIQUE", payload })
  };
}
